import { render, staticRenderFns } from "./ColumnForm.vue?vue&type=template&id=b450d136&scoped=true&"
import script from "./ColumnForm.vue?vue&type=script&lang=ts&"
export * from "./ColumnForm.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnForm.vue?vue&type=style&index=0&id=b450d136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b450d136",
  null
  
)

export default component.exports